import React, { useContext } from 'react';
import { MergeCellsOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import SoftwareContext from '@totem/components/software/software_report/softwareContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const styles = {
  button: {
    marginRight: '20px',
  },
};

export interface Props {
  isPrimary?: boolean;
}
const MergeButton = ({ isPrimary }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { selectedPackages, action, onAction } = useContext(SoftwareContext);
  const canAdmin =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  return (
    <IBTooltip content={permissions.internalSystemAdministrator.tooltip}>
      <Button
        style={styles.button}
        icon={<MergeCellsOutlined />}
        type={
          typeof isPrimary !== 'undefined' && isPrimary ? 'primary' : 'default'
        }
        disabled={
          !canAdmin ||
          action === 'merge' ||
          typeof selectedPackages === 'undefined' ||
          selectedPackages === null ||
          selectedPackages.length < 2
        }
        onClick={() => onAction('merge', null)}
      >
        Merge
      </Button>
    </IBTooltip>
  );
};

export default MergeButton;
